import * as React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout/index'
import Search from 'components/UI/PageSearch'
// context
import { SystemProcessesPageContext } from 'containers/SystemProcesses/Table/layers/API'
// view components
import SystemProcessesTable from 'components/PageComponents/Settings/SystemProcesses/components/Table'
import CreateSystemProcessButton from 'components/CTAs/CreateSystemProcess'
import SystemProcessDetailsDrawer from 'components/Modals/SystemProcessModal'
// themes
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const SystemProcessesPageContent: React.FC = () => {
  const { isLoading } = React.useContext(SystemProcessesPageContext)

  return (
    <>
      <Helmet>
        <title>Skefto - System Processes</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={isLoading}
        CTA={
          <>
            <Search name={'search'} />
            <CreateSystemProcessButton />
          </>
        }>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <SystemProcessesTable />
        </LayoutContainerInnerWrapper>
        <SystemProcessDetailsDrawer />
      </MainLayoutContainer>
    </>
  )
}

export default SystemProcessesPageContent
